import { Card, CardContent } from "../../../../../components/ui/card";
import { cn } from "../../../../../lib/utils";

interface StatCardProps {
  title: string;
  value: string;
  icon: React.ReactNode;
  className?: string;
}

export function StatCard({ title, value, icon, className }: StatCardProps) {
  return (
    <Card className={cn("", className)}>
      <CardContent className="pt-6">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <p className="text-2xl font-bold mt-2 break-words">{value}</p>
          </div>
          <div className="ml-4 text-muted-foreground">{icon}</div>
        </div>
      </CardContent>
    </Card>
  );
}
